import { render, staticRenderFns } from "./israel.vue?vue&type=template&id=24619aa6"
import script from "./israel.vue?vue&type=script&lang=js"
export * from "./israel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchBox: require('/vercel/path0/components/SearchBox.vue').default,Container: require('/vercel/path0/components/common/Container.vue').default,AppHero: require('/vercel/path0/components/common/AppHero.vue').default})
